<div class="flex grow" [formGroup]="formGroup">
  <app-input
    data-qa="carryInterestPercent"
    class="left-carry-input"
    [title]="'Total carry'"
    [suffixText]="'%'"
    [formControl]="formGroup.controls.carryInterestPercent"
    [separator]="'separator.6'"
    [thousandSeparator]="','">
  </app-input>
  <app-input
    data-qa="carryInterest"
    class="right-carry-input"
    [formControl]="formGroup.controls.carryInterest"
    [allowNegativeNumbers]="true"
    [separator]="'separator.0'"
    [thousandSeparator]="','">
  </app-input>
</div>
